// extracted by mini-css-extract-plugin
export var annotation = "e_bD_fb";
export var annotationWrapper = "e_bD_d9";
export var cardContainer = "e_bD_c2";
export var contentWrapper = "e_bD_cB";
export var screenTablet = "768px";